import { Platform } from '../models/api/common';

/**
 * Checks if the platform is an outpost platform type.
 * Outpost platforms have limited functionality (e.g., no fetch content).
 */
export function isOutpostPlatform(platform: Platform | string | undefined): boolean {
  return platform === Platform.outpostPowerPlatform;
}

export function getPlatformLogoPath(platform: Platform) {
  switch (platform) {
    case Platform.powerplatform:
    case Platform.outpostPowerPlatform:
      return 'assets/images/logo/ms-logo.svg';
    case Platform.powerBI:
      return 'assets/images/logo/power-bi-logo.svg';
    case Platform.workato:
      return 'assets/images/logo/workato-logo.svg';
    case Platform.salesforce:
      return 'assets/images/logo/salesforce-logo.png';
    case Platform.serviceNow:
      return 'assets/images/logo/serviceNow-logo.svg';
    case Platform.chatGptEnterprise:
      return 'assets/images/logo/chatGptEnterprise.svg';
    case Platform.amazonBedrock:
      return 'assets/images/logo/aws-logo.svg';
    case Platform.google:
      return 'assets/images/logo/google-logo.svg';
    case Platform.devices:
      return 'assets/images/logo/devices-logo.svg';
    case Platform.budibase:
      return 'assets/images/logo/budibase-logo.svg';
    case Platform.airtable:
      return 'assets/images/logo/airtable-logo.svg';
    case Platform.outpost_powerplatform:
      return 'assets/images/logo/power-platform-logo.svg';
    case Platform.customAgent:
      return 'assets/images/logo/zenity-logo.svg';
    case Platform.cursor:
      return 'assets/images/logo/cursor-logo.svg';
    default:
      console.warn(`getPlatformLogoPath: platform ${platform} not supported`);
      return 'assets/images/logo/zenity-logo.svg';
  }
}

export function getPlatformDisplayName(platform: Platform) {
  switch (platform) {
    case Platform.powerplatform:
      return 'Microsoft';
    case Platform.outpostPowerPlatform:
      return 'Microsoft Outpost';
    case Platform.powerBI:
      return 'Fabric';
    case Platform.serviceNow:
      return 'ServiceNow';
    case Platform.workato:
      return 'Workato';
    case Platform.salesforce:
      return 'Salesforce';
    case Platform.chatGptEnterprise:
      return 'ChatGPT Enterprise';
    case Platform.amazonBedrock:
      return 'Amazon';
    case Platform.google:
      return 'Google';
    case Platform.devices:
      return 'Devices';
    case Platform.budibase:
      return 'Budibase';
    case Platform.airtable:
      return 'Airtable';
    case Platform.outpost_powerplatform:
      return 'Outpost Power Platform';
    case Platform.customAgent:
      return 'Custom Agent';
    case Platform.cursor:
      return 'Cursor';
    default:
      console.warn(`getPlatformDisplayName: platform ${platform} not supported`);
      return platform;
  }
}
